const source = 'podsDataTable'

function sospensioni () {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-sospensioni-riattivazioni',
      title: 'Sospensioni',
      data: {ids, type:'sospensioni'},
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': sospensioni,
}
